module.exports = __webpack_public_path__ + "img/symbol_2.3f995b8d.png";